import { createStore } from "vuex";
import user, { UserState } from "./modules/user";
import tabs, { TabState } from "./modules/tabs";
import menu, { menuState } from "./modules/menu";
import keepAlive, { keepAliveState } from "./modules/keepAlive";
import globalState, { GlobalState } from "./modules/globalState";
import language, { LanguageState } from "./modules/language";

export interface AllState {
  user: UserState;
  tabs: TabState;
  menu: menuState;
  keepAlive: keepAliveState;
  globalState: GlobalState;
  language: LanguageState
}

// 实例化
const store = createStore<AllState>({
  modules: {
    user,
    tabs,
    menu,
    keepAlive,
    globalState,
    language
  },
});

export default store;
